import {Injectable} from '@angular/core';

/**
 * Translations for creating customer.
 */
@Injectable()
export class CreateCustomerTranslationsService {
  public i18nSuccessCustomerCreate: any = $localize`:@@alertService.alert.success.customerCreate:Customer was created successfully!`;
  public i18nErrorCustomerCreate: any = $localize`:@@alertService.alert.error.customerCreate:Error occurred. Customer could not be created.`;
  constructor() { }
}
